import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { setupCalendar } from 'v-calendar';

import { initSentry } from '@/sentry';
import { keycloakApi } from '@/connection/keycloak-api';
import { useNutzerStore } from '@/shared/Nutzer/useNutzerStore';
import { countdownService } from '@/service/CountdownService';
import { useFeatureToggles } from '@/shared/useFeatureToggles/useFeatureToggles';
import i18nPlugin from '@/lang/i18nPlugin';
import { setupConfig } from '@tl/design-system';

// Importiere virtuelles Sentry Config Module vom vite Plugin.
// Damit werden die "dist" und "release" Settings des Build Prozesses genutzt
import 'virtual:vite-plugin-sentry/sentry-config';

import App from './App.vue';
import router from './router';

import '@/shared/Validierung/initYup';

// Add DS Font Setup
import '@tl/design-system/assets/fonts.css';
import '@tl/design-system/styles.css';

// Import unserer Styles
import '../public/static/assets/style.css';
import 'v-calendar/style.css';

const app = createApp(App);
const pinia = createPinia();

initSentry(app);

keycloakApi
  .init()
  .then((auth) => {
    if (!auth) {
      window.location.reload();
    } else {
      const { plugin, config } = useFeatureToggles();

      app.use(i18nPlugin);
      app.use(pinia);
      app.use(router);
      app.use(setupCalendar, {});
      app.use(setupConfig({ teleportTarget: '.teleport' }));
      if (import.meta.env.VITE_UNLEASH_API_KEY && import.meta.env.VITE_UNLEASH_URL) {
        app.use(plugin, { config });
      }

      useNutzerStore().ladeNutzer();

      app.mount('#app');
      // Start des Session-Timers
      countdownService.start();
    }
  })
  .catch(() => {});

// Start des Session-Timers
countdownService.start();
